<app-page-header *ngIf="!disableHeader" header="{{language.fundunitheader}}"
    backgroundPath="assets/images/lead/lead-calculate.jpg"></app-page-header>
<ngx-ui-loader></ngx-ui-loader>
<section class="content-inner">
    <!-- First Investment Units -->
    <div class="first-investment">
        <div class="container">
            <section class="section _intro">
                <header>
                    <h2 class="topic-title">{{language.cs_title}}</h2>
                </header>
                <!-- <div class="col-sm-4 col-lg-3">
                    <app-button class="download-form" text="{{language.cs_edoc}}" (click)="goClientReport()"
                        style="position: relative;">
                    </app-button>
                </div> -->
                <div class="row" style="justify-content: center;">
                    <div class="dropdown col-sm-4 col-md-9 col-lg-4" style="margin-bottom: 10px;">
                        <a class="btn btn-warning dropdown-toggle fontfundser" href="#" role="button"
                            id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{language.cs_edoc}}
                        </a>

                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a *ngIf="language_flag == 'th'" class="dropdown-item item_drop1"
                                [routerLink]="['/client-report/','AP']">{{language.cs_edoc_profile}}</a>
                            <a class="dropdown-item item_drop2"
                                [routerLink]="['/client-report/','AITE']">{{language.cs_edoc_dropdown1}}</a>
                            <a class="dropdown-item item_drop2"
                                [routerLink]="['/client-report/','ED']">{{language.cs_edoc_dropdown2}}</a>
                            <a *ngIf="language_flag == 'th'" class="dropdown-item item_drop4"
                                [routerLink]="['/client-report/','RCC']">{{language.cs_edoc_dropdown4}}<br>{{language.cs_edoc_onlyOne}}</a>
                            <a *ngIf="language_flag == 'en'" class="dropdown-item item_drop4" style="padding-top: 24px;"
                                [routerLink]="['/client-report/','RCC']">{{language.cs_edoc_dropdown4}}<br>{{language.cs_edoc_onlyOne}}</a>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-9 col-lg-4">
                        <app-button class="download-form fontfundser" text="{{language.fundopenaccountpine}}"
                            (click)="goOpenAccountPine()">
                        </app-button>
                    </div>
                    <div class="col-sm-4 col-md-9 col-lg-4">
                        <app-button class="download-form fontfundser" text="{{language.fundunitdownloadbtn}}"
                            (click)="goDownloadPage()">
                        </app-button>
                    </div>
                </div>
                <!-- <header>
                    <h2 class="topic-title">{{language.cs_title}}</h2>
                    <span *ngIf="requestOTP" class="desc">
                        {{getOTPTitle()}}
                    </span>
                    <span *ngIf="showLogin" class="desc">
                        {{language.cs_pid_title}}<br>{{language.cs_pid_title2}}
                    </span>

                </header>
                <div class="form--item">
                    <div class="row" *ngIf="showLogin">
                        <div class="input col-sm-12 col-md-5 col-lg-4">
                            <div class="input--container">
                            <input placeholder="{{language.cs_pid}}" [(ngModel)]="personalID" required type="text" name="personalID"
                                class="form-control" />
                            </div>
                            <div *ngIf="pidReq" class="error-message">{{loginError}}</div>
                        </div>
                        <div class="col-sm-12 col-md-2 col-lg-2">
                            <app-button class="download-form" text="{{language.cs_login}}" (click)="checkLogin()">
                            </app-button>
                        </div>
                    </div>
                    <div class="row" *ngIf="requestOTP">
                        <div class="input col-sm-12 col-md-5 col-lg-4">
                            <div class="input--container">
                            <input placeholder="{{language.cs_otp}}" [(ngModel)]="inputOTP" required type="text" name="inputOTP"
                                class="form-control" />
                            </div>
                            <div *ngIf="otpReq" class="error-message">{{otpError}}</div>
                        </div>
                        <div class="col-sm-12 col-md-2 col-lg-2">
                            <app-button class="download-form" text="{{language.cs_login}}" (click)="checkOTP()">
                            </app-button>
                        </div>
                        <div class="col-sm-12 col-md-3 col-lg-3">
                            <app-button class="download-form" text="{{language.cs_request_otp}}" (click)="checkLogin()">
                            </app-button>
                        </div>
                    </div>
                </div>  -->
            </section>

            <section class="section _first-invest" *ngIf="showPDPA">
                <!-- <section class="section _first-invest"> -->
                <div class="row">
                    <div class="col-sm-4 col-lg-3">
                        <app-button class="download-form" text="{{language.cs_consent}}" (click)="openConsent()">
                        </app-button>
                    </div>
                    <div class="col-sm-4 col-lg-3">
                        <app-button class="download-form" text="{{language.cs_dsar}}" (click)="openDSAR()">
                        </app-button>
                    </div>
                </div>
            </section>

            <section class="section _intro">
                <div class="row" style="align-items: center;">
                    <div class="col-sm-8 col-lg-9 ">
                        <p>
                            {{language.fundunitcontact1}}
                        </p>
                    </div>
                    <!-- <div class="col-sm-4 col-lg-3">
                        <app-button class="download-form" text="{{language.fundopenaccountpine}}"
                            (click)="goOpenAccountPine()">
                        </app-button>
                        <app-button class="download-form" text="{{language.fundunitdownloadbtn}}"
                            (click)="goDownloadPage()">
                        </app-button>
                    </div> -->
                </div>
            </section>

            <!-- <section class="section _first-invest">
                <header>
                    <h2 class="topic-title">{{language.fundunittopic1}}</h2>
                    <span class="desc">
                        {{language.fundunitdetailtopic1}}
                    </span>
                </header>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toppic">
                            <img src="../assets/images/ic-people@2x.png">
                            <h5 style="font-size: 24px;">{{language.fundunittitle1}}</h5>
                            <span>{{language.fundunittitle1detail1}}</span>
                        </div>
                        <ol class="list list-invest">
                            <li>
                                {{language.fundunittitle1detail2}}
                            </li>
                            <li>
                                {{language.fundunittitle1detail3}}
                            </li>
                            <li>
                                {{language.fundunittitle1detail4}}
                                <ol class="list list-unstyled list-sub">
                                    <li>
                                        <span>3.1.</span>
                                        {{language.fundunittitle1detail5}}
                                        <ol class="list list-unstyled list-sub-ofsub keep-right">
                                            <li>
                                                {{language.fundunittitle1detail6}}
                                            </li>
                                            -- <li>
                                                {{language.fundunittitle1detail7}}
                                            </li> --
                                            <li>
                                                {{language.fundunittitle1detail8}}
                                            </li>
                                        </ol>
                                    </li>
                                    <li>
                                        <span>3.2.</span>
                                        {{language.fundunittitle1detail9}}
                                        <ol class="list list-unstyled list-sub-ofsub keep-right">
                                            <li>
                                                {{language.fundunittitle1detail10}}
                                            </li>
                                            <li>
                                                {{language.fundunittitle1detail11}}
                                            </li>
                                            -- <li>
                                                {{language.fundunittitle1detail12}}
                                            </li> --
                                            <li>
                                                {{language.fundunittitle1detail13}}
                                            </li>
                                            <li>
                                                {{language.fundunittitle1detail14}}
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>
                            <li>{{language.fundunittitle1detail15}}</li>
                        </ol>
                    </div>
                    <div class="col-lg-6">
                        <div class="toppic">
                            <img src="../assets/images/ic-people@2x.png" width="21">
                            <h5 style="font-size: 24px;">{{language.fundunittitle2}}</h5>
                            <span>{{language.fundunittitle2detail1}}</span>
                        </div>
                        <ol class="list list-invest">
                            <li>
                                {{language.fundunittitle2detail2}}
                            </li>
                            <li>
                                {{language.fundunittitle2detail3}}
                                <ol class="list list-unstyled list-sub">
                                    <li>
                                        <span>2.1.</span>
                                        {{language.fundunittitle2detail4}}
                                    </li>
                                    <li>
                                        <span>2.2.</span>
                                        {{language.fundunittitle2detail5}}
                                    </li>
                                    <li>
                                        <span>2.3.</span>
                                        {{language.fundunittitle2detail6}}
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                </div>
            </section> -->

            <section class="section _get-money">
                <header>
                    <h2 class="topic-title">{{language.fundunittopic2}}</h2>
                    <span class="desc">
                        {{language.fundunitdetailtopic2}}
                    </span>
                </header>
                <ol class="list list-invest">
                    <li>{{language.fundunittopic2detail1}}</li>
                    <li>{{language.fundunittopic2detail2}}</li>
                    <li>{{language.fundunittopic2detail3}}</li>
                    <li>{{language.fundunittopic2detail4}}</li>
                    <li>{{language.fundunittopic2detail5}}</li>
                    <li>{{language.fundunittopic2detail6}}</li>
                    <li>{{language.fundunittopic2detail7}}</li>
                    <li>{{language.fundunittopic2detail8}}</li>
                    <li>{{language.fundunittopic2detail9}}</li>
                    <li>{{language.fundunittopic2detail10}}</li>
                    <li>
                        {{language.fundunittopic2detail11}}
                    </li>
                    <li>{{language.fundunittopic2detail12}}</li>
                    <li>{{language.fundunittopic2detail13}}</li>
                    <!-- <li>{{language.fundunittopic2detail14}}</li> -->
                </ol>
            </section>

            <section class="section section-group section-table pt-0">
                <header>
                    <h2 class="topic-title">{{language.fundunittopic3}}</h2>
                    <span class="desc">
                        {{language.fundunitdetailtopic3}}
                    </span>
                </header>
                <div id="nav-history-render">
                    <table class="table table--fund table-striped table-hover fixed-columns table-align-left-first"
                        width="100%">
                        <thead>
                            <tr>
                                <th>{{language.fundunittablehead1}}</th>
                                <th>{{language.fundunittablehead2}}</th>
                                <th>{{language.fundunittablehead3}}</th>
                                <th>{{language.fundunittablehead4}}</th>
                                <th>{{language.fundunittablehead5}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{language.fundunitrow1detail1}}</td>
                                <td>{{language.fundunitrow1detail2}}</td>
                                <td>{{language.fundunitrow1detail3}}</td>
                                <td>{{language.fundunitrow1detail4}}</td>
                                <td>{{language.fundunitrow1detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow2detail1}}</td>
                                <td>{{language.fundunitrow2detail2}}</td>
                                <td>{{language.fundunitrow2detail3}}</td>
                                <td>{{language.fundunitrow2detail4}}</td>
                                <td>{{language.fundunitrow2detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow3detail1}}</td>
                                <td>{{language.fundunitrow3detail2}}</td>
                                <td>{{language.fundunitrow3detail3}}</td>
                                <td>{{language.fundunitrow3detail4}}</td>
                                <td>{{language.fundunitrow3detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow4detail1}}</td>
                                <td>{{language.fundunitrow4detail2}}</td>
                                <td>{{language.fundunitrow4detail3}}</td>
                                <td>{{language.fundunitrow4detail4}}</td>
                                <td>{{language.fundunitrow4detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow5detail1}}</td>
                                <td>{{language.fundunitrow5detail2}}</td>
                                <td>{{language.fundunitrow5detail3}}</td>
                                <td>{{language.fundunitrow5detail4}}</td>
                                <td>{{language.fundunitrow5detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow6detail1}}</td>
                                <td>{{language.fundunitrow6detail2}}</td>
                                <td>{{language.fundunitrow6detail3}}</td>
                                <td>{{language.fundunitrow6detail4}}</td>
                                <td>{{language.fundunitrow6detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow7detail1}}</td>
                                <td>{{language.fundunitrow7detail2}}</td>
                                <td>{{language.fundunitrow7detail3}}</td>
                                <td>{{language.fundunitrow7detail4}}</td>
                                <td>{{language.fundunitrow7detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow8detail1}}</td>
                                <td>{{language.fundunitrow8detail2}}</td>
                                <td>{{language.fundunitrow8detail3}}</td>
                                <td>{{language.fundunitrow8detail4}}</td>
                                <td>{{language.fundunitrow8detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow9detail1}}</td>
                                <td>{{language.fundunitrow9detail2}}</td>
                                <td>{{language.fundunitrow9detail3}}</td>
                                <td>{{language.fundunitrow9detail4}}</td>
                                <td>{{language.fundunitrow9detail5}}</td>
                            </tr>
                            <!-- <tr>
                                <td>{{language.fundunitrow10detail1}}</td>
                                <td>{{language.fundunitrow10detail2}}</td>
                                <td>{{language.fundunitrow10detail3}}</td>
                                <td>{{language.fundunitrow10detail4}}</td>
                                <td>{{language.fundunitrow10detail5}}</td>
                            </tr> -->
                            <tr>
                                <td>{{language.fundunitrow11detail1}}</td>
                                <td>{{language.fundunitrow11detail2}}</td>
                                <td>{{language.fundunitrow11detail3}}</td>
                                <td>{{language.fundunitrow11detail4}}</td>
                                <td>{{language.fundunitrow11detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow12detail1}}</td>
                                <td>{{language.fundunitrow12detail2}}</td>
                                <td>{{language.fundunitrow12detail3}}</td>
                                <td>{{language.fundunitrow12detail4}}</td>
                                <td>{{language.fundunitrow12detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow13detail1}}</td>
                                <td>{{language.fundunitrow13detail2}}</td>
                                <td>{{language.fundunitrow13detail3}}</td>
                                <td>{{language.fundunitrow13detail4}}</td>
                                <td>{{language.fundunitrow13detail5}}</td>
                            </tr>
                            <tr>
                                <td>{{language.fundunitrow14detail1}}</td>
                                <td>{{language.fundunitrow14detail2}}</td>
                                <td>{{language.fundunitrow14detail3}}</td>
                                <td>{{language.fundunitrow14detail4}}</td>
                                <td>{{language.fundunitrow14detail5}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="content-desc">
                    <span class="desc">
                        {{language.fundunitbottomdetail1}}
                    </span>
                    <div class="blog-call">
                        <img src="../assets/images/ic-call@2x.png">
                        <p>
                            {{language.fundunitbottomdetail2}}
                            <br> {{language.fundunitbottomdetail3}}
                        </p>
                    </div>
                    <span class="desc">
                        {{language.fundunitbottomdetail4}}
                        <br>
                        <br> {{language.fundunitbottomdetail5}}
                        <span class="sp">
                            {{language.fundunitbottomdetail6}}
                        </span>
                        {{language.fundunitbottomdetail7}}
                    </span>
                    <ol class="list list-bank">
                        <li>{{language.fundunitlistbank1}}</li>
                        <li>{{language.fundunitlistbank2}}</li>
                        <li>{{language.fundunitlistbank3}}</li>
                        <li>{{language.fundunitlistbank4}}</li>
                        <li>{{language.fundunitlistbank5}}</li>
                        <li>{{language.fundunitlistbank6}}</li>
                        <li>{{language.fundunitlistbank7}}</li>
                        <li>{{language.fundunitlistbank8}}</li>
                        <li>{{language.fundunitlistbank9}}</li>
                        <li>
                            {{language.fundunitlistbank10}}
                        </li>
                        <li>{{language.fundunitlistbank11}}</li>
                        <li>{{language.fundunitlistbank12}}</li>
                        <!-- <li>{{language.fundunitlistbank13}}</li> -->
                    </ol>
                    <span class="desc">
                        {{language.fundunitsummary1}}
                    </span>
                    <span class="note">
                        {{language.fundunitsummary2}}&nbsp;{{language.fundunitsummary3}}
                    </span>
                </div>
            </section>



            <section class="section _get-money" *ngIf="language_flag == 'th'">

                <div class="content-desc">

                    <span class="desc">
                        <h2 class="topic-title">{{language.direct_debit1}}</h2>{{language.direct_debit1_1}}
                    </span>
                    <ol class="list list-bank">
                        <li>{{language.direct_debit2}}</li>
                        <li>{{language.direct_debit3}}</li>
                        <li>{{language.direct_debit4}}</li>
                    </ol>
                </div>
            </section>


            <div class="row d-flex justify-content-center" *ngIf="language_flag == 'th'">
                <div class="col-lg-12 d-flex justify-content-center">
                    <img src="../../../assets/images/Direct_Debit_Payment.png" style="width: 100%; height: auto;">
                </div>
            </div>

            <section class="section _get-money" *ngIf="language_flag == 'th'">

                <div class="content-desc">
                    <ol class="list list-bank" start="4">
                        <li>{{language.direct_debit5}}</li>
                    </ol>
                </div>
            </section>

            <section class="section _get-money" *ngIf="language_flag == 'th'">

                <div class="content-desc">

                    <span class="desc">
                        {{language.direct_debit6}}
                    </span>

                    <ol class="list list-bank">
                        <li>{{language.direct_debit7}}</li>
                        <li>{{language.direct_debit8}}</li>
                        <li>{{language.direct_debit9}}</li>
                    </ol>

                    <span class="note">
                        {{language.direct_debit10}}
                    </span>

                </div>
            </section>


        </div>

    </div>

    <!-- /First Investment Units -->

</section>